//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START OF IMPORTS////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Button, ListItemText, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';


//////////////////////////////////////STUFF RELATED TO TABLE
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import AppBar from '@mui/material/AppBar';
import Grid from "@mui/material/Grid";
import { Query } from "react-apollo";



import CssBaseline from '@mui/material/CssBaseline';

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';




const gql = require("apollo-boost").gql;

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF IMPORTS//////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START  OF CLIENT CONFIG/////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////





//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF CLIENT CONFIG////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START OF QUERY//////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////


const INCIDENT_REPORT_QUERY = gql`
  query incidentReportQuery(
    $buildingId:uuid!
  ) {
  Incident(where: {Shift_Gaurd: {Shift: {Building: {Id: {_eq: $buildingId}}}, Gaurd: {GaurdFirstName: {_neq: "Lobi"}}}, Resolved: {_eq: false}}) {
    Description
    EndDateTime
    Id
    ImageUrl
    Lat
    Long
    Resolution
    Resolved
    ShiftGaurdId
    StartDateTime
    Title
    created_at
    updated_at
    Shift_Gaurd {
      Gaurd {
        GaurdFirstName
      }
    }
  }
}`;



//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF QUERY////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START MAIN COMPONENT DEFINITION/////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

export class Report_template_2 extends Component {

  componentWillMount = async () => {
    console.log("componentWillMount");
  };

  componentDidMount = () => {
    console.log("componentDidMount");
  };

  render() {
    /////////////////////////////////////
    // Helper functions
    ////////////////////////////////////
    const theme = createTheme();

    const rows = this.props.incidents;

    rows.forEach(function (item, index) {
      console.log(item, index);
    })

    return (


      < ThemeProvider theme={theme} >
        <CssBaseline />
        <AppBar position="relative">
          <Toolbar>

            <Typography variant="h6" color="inherit" noWrap>
              Incident Report
            </Typography>
          </Toolbar>
        </AppBar>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, maxWidth: 50 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Incident Title</TableCell>
                <TableCell>Incident Description</TableCell>
                <TableCell align="right">Time Reported</TableCell>
                <TableCell align="right">Resolved?</TableCell>
                <TableCell align="right">Reported By</TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.Id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.Title}
                  </TableCell>
                  <TableCell align="right">{row.Description}</TableCell>
                  <TableCell align="right">{row.created_at}</TableCell>
                  <TableCell align="right">{row.Resolved}</TableCell>
                  <TableCell align="right">{row.Shift_Gaurd.Gaurd.GaurdFirstName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ThemeProvider >

    );
  }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END MAIN COMPONENT DEFINITION///////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////START OF HELPER FUNCTION////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////END OF HELPER FUNCTION//////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////


const IncidentQuery = (props) => {
  console.log(props);
  const variables = {
    buildingId: props.buildingId
  };
  return (
    <Query query={INCIDENT_REPORT_QUERY} variables={variables}>
      {({ loading, error, data, client }) => {
        if (loading) {
          return <div>loading...</div>;
        }
        if (error) {
          console.log("Output: : error", error);
          return <div>Error</div>;
        }

        return (
          <Report_template_2
            client={client}
            buildingId={props.buildingId}
            incidents={data.Incident}
          ></Report_template_2>
        );
      }}
    </Query>
  );
};


export default IncidentQuery;